import { FaPoll } from "react-icons/fa"
import { useState } from "react"
import TablaPlantillas from "../components/encuestasSatisfaccion/TablaPlantillas"
import TablaEncuestasResueltas from "../components/encuestasSatisfaccion/TablaEncuestasResueltas"

const EncuestasPlantillas = () => {

  const [viewMode, setViewMode] = useState("Plantillas")
  const [limit, setLimit] = useState(15)

  return (
    <div className="h-screen flex flex-col">

      <div className="px-4 py-2 bg-gray-100 mb-1">
        <div className="flex flex-row w-full items-center gap-4 justify-between">

          <div className="flex items-center gap-4 py-4">
            <FaPoll className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Encuestas</h2>
          </div>

          <div className="flex flex-row gap-8 items-center justify-center">

            <div className="flex flex-row items-center justify-center gap-4">
              <label htmlFor="filteringCriteria" className="text-xs">Límite</label>
              <select
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
                className={`bg-gray-50 text-xs border hover:cursor-pointer border-gray-300 text-gray-900 w-full text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-1 px-2`}
              >
                <option value="15">15</option>
                <option value="25">25</option>
                <option value="35">35</option>
                <option value="45">45</option>
                <option value="55">55</option>
              </select>
            </div>

            <div className="flex flex-row items-center justify-center gap-4">
              <label htmlFor="filteringCriteria" className="text-xs">Vista</label>
              <select
                value={viewMode}
                onChange={(e) => setViewMode(e.target.value)}
                className={`bg-gray-50 text-xs border hover:cursor-pointer border-gray-300 text-gray-900 w-full text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-1 px-2`}
              >
                <option value="Plantillas">Plantillas</option>
                <option value="Encuestas resueltas">Encuestas resueltas</option>
              </select>
            </div>
          </div>

        </div>
      </div>

      {viewMode === "Plantillas" ? <TablaPlantillas limit={limit} /> : <TablaEncuestasResueltas limit={limit}/>}

    </div>
  )
}

export default EncuestasPlantillas